// @flow

import { EventDataDto } from 'rest/alerts/alerts.event-data.dto';

export const findEvent = (eventData: EventDataDto[], eventName: string): string => {
  const event = eventData.find(event => event.name === eventName);
  return !!event && event.value;
};
